// @flow
import * as React from 'react';
import classNames from 'classnames';
import Button from './Button';

import './ExpandButton.css';

type Props = {
  isExpanded: boolean,
  onClick: Function,
  icon: string,
  visibility ?: boolean
};

export default class ExpandButton extends React.Component<Props, {}> {
  render() {
    const { isExpanded, onClick, icon, visibility } = this.props;
    return (
      <Button
        Name = "ExpandBtn"
        className={classNames('ExpandButton', { expanded: isExpanded })}
        style = {{visibility : visibility ? 'hidden' : 'visible'}}
        icon={icon ? icon : 'images/triangle_gray.svg'}
        onClick={onClick}
      />
    );
  }
}
